import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

function SearchBox() {
    const [keyword, setKeyword] = useState('');

    let history = useHistory();

    const submitHandler = (e) => {
        e.preventDefault();
        if (keyword) {
            // Clear filters when performing a search
            history.push(`/?keyword=${keyword}&page=1`);
        } else {
            history.push(history.location.pathname);
        }
    };

    return (
        <Form onSubmit={submitHandler} inline className='wrapper'>
            <Form.Control
                type='input'
                name='q'
                onChange={(e) => setKeyword(e.target.value)}
                className='search'
            ></Form.Control>

            <Button
                type='submit'
                variant='dark'
                className='search-submit-button'
            >

            </Button>
        </Form>
    );
}

export default SearchBox;
